import { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import CountUp from "react-countup";
import { useDispatch, useSelector } from "react-redux";
import { getModuleListing, getRankStatus } from "../../redux/courses/actions";
import { SessionKeys } from "../../utils/AppUtils";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import "./AfterCongratulationsModal.scss";
function AfterCongratulationsModal(props) {
  const { show, setShow, rank, isMobile } = props; // fromPage ==> 0 = learningpoint, 1 = badge, 2 = certificate
  const navigate = useNavigate();

  return (
    <>
      <div className="modal show" style={{ display: "block" }}>
        <Modal
          show={show}
          onHide={() => setShow(false)}
          size="800px"
          aria-labelledby="contained-modal-title-vcenter"
          className="bg-cograts"
          centered
        >
          <Modal.Header
            closeButton
            className="modal-header-congrats"
          ></Modal.Header>
          <Modal.Body className="congratulationmodalop">
            <div className="imgcg text-center">
              <img src="/images/congratsanime.gif" width={300}/>
            </div>

            <div className="congrtsboxsvg">
              <h4>Congratulations</h4>
              <p>
                Congratulations! you have advanced to the leaderboard Rank{" "}
                {rank}!
              </p>
              <p
                className="link"
                onClick={() => {
                  if(isMobile) {
                    let obj = {method:"navigate-to-leaderboard" };
                    if (window.callbackHandler != undefined) {
                      window.callbackHandler.postMessage(
                        JSON.stringify(obj)
                      );
                    } else if (window.webkit != undefined) {
                      if (
                        window.webkit.messageHandlers.callbackHandler !=
                        undefined
                      ) {
                        window.webkit.messageHandlers.callbackHandler.postMessage(
                          JSON.stringify(obj)
                        );
                      }
                    }
                  }
                  else {
                  navigate("/leaderboard");
                  }
                }}
              >
                Click here to view the leaderboard
              </p>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default AfterCongratulationsModal;
